import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { HomeExploreComponent } from "./home-explore/home-explore.component";
import { HomeBuyNowComponent } from "./home-buy-now/home-buy-now.component";
import { HomeLayoutComponent } from "./home-layout/home-layout.component";
import { HomeJumbotronComponent } from "./home-jumbotron/home-jumbotron";
import { HomeRentingInfoComponent } from "./home-renting-info/home-renting-info.component";
import { HomeWeKnowComponent } from "./home-we-know/home-we-know.component";
import { MarketingModule } from "@rubbl-marketing";
import { SearchResultsModule } from "@rubbl-search-results";
import { LayoutModule } from "@rubbl-layout";
import { HomePopularCategoriesComponent } from './home-popular-categories/home-popular-categories.component';

const routes: Routes = [
  {
    path: "",
    component: HomeLayoutComponent,
  },
];

@NgModule({
  declarations: [HomeLayoutComponent, HomeJumbotronComponent, HomeExploreComponent, HomeBuyNowComponent, HomeRentingInfoComponent, HomeWeKnowComponent, HomePopularCategoriesComponent],
  imports: [RouterModule.forChild(routes), FormsModule, SharedModule, MarketingModule, SearchResultsModule, LayoutModule],
})
export class HomeModule { }
